/* eslint-disable no-undef */
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Router from "./components/Router";
import InfoSnackbar from "./components/InfoSnackbar";
import CustomerThemeProvider from "./components/CustomThemeProvider";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { RecoilRoot } from "recoil";

const msalInstance = new PublicClientApplication(msalConfig);

// Create a client for react-query
const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      {/* @feddo need to remove redux I think - styles or something depends on it?*/}
      <Provider store={store}>
        <RecoilRoot>
          <CustomerThemeProvider>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <QueryClientProvider client={queryClient}>
                {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                <CssBaseline />
                <InfoSnackbar />
                <Router />
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </MuiPickersUtilsProvider>
          </CustomerThemeProvider>
        </RecoilRoot>
      </Provider>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
